<script lang="ts">
const edgeGap = 16
</script>
<script setup lang="ts">
// This import makes some issues with useTemplateRef go away
import DropdownMenu from "../Dropdown/DropdownMenu.vue"

const props = defineProps({
  x: null,
  y: null
})


const menu = useTemplateRef("menu")
const page = document.body.getBoundingClientRect()
const staticX = props.x
const staticY = props.y
const left = computed(() => {
  if (!menu.value?.container)
    return px(0)
  const width = menu.value.container.getBoundingClientRect().width || 0
  return px(clamp(staticX, edgeGap, page.width - width - edgeGap))
})
const top = computed(() => {
  if (!menu.value?.container)
    return px(0)
  const height = menu.value.container.getBoundingClientRect().height || 0
  return px(clamp(staticY, edgeGap, page.height - height - edgeGap))
})
</script>

<template>
  <dropdown-menu
    ref="menu"
    class="fixed-menu"
    :style="{ left, top }"
  >
    <slot />
  </dropdown-menu>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.fixed-menu
  @apply w-[#{$menu-context-w-default}] fixed
</style>
